import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  z-index: 1500;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: ${({ $loud }) =>
    $loud ? "rgba(15, 23, 42, 0.62)" : "rgba(33, 41, 52, 0.32)"};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Modal = styled.div`
  width: ${({ $loud }) => ($loud ? "540px" : "450px")};
  max-width: calc(100vw - 32px);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(33, 41, 52, 0.16);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: ${({ $loud }) => ($loud ? "center" : "stretch")};
  padding: ${({ $loud }) => ($loud ? "40px 32px 28px" : "16px")};
  ${({ $loud }) =>
    $loud &&
    `
    border: 3px solid #16A34A;
  `}
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 16px;
  top: 16px;
  background: none;
  border: none;
  font-size: 20px;
  color: #aeb8c4;
  cursor: pointer;
`;

export const TickFrame = styled.div`
  width: 40px;
  height: 40px;
  background: #e3f0ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

export const LoudCheck = styled.div`
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: #dcfce7;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

export const Title = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: ${({ $loud }) => ($loud ? 800 : 600)};
  font-size: ${({ $loud }) => ($loud ? "32px" : "20px")};
  line-height: ${({ $loud }) => ($loud ? "40px" : "30px")};
  color: ${({ $loud }) => ($loud ? "#14532D" : "#1b2028")};
  margin-bottom: 8px;
  text-align: ${({ $loud }) => ($loud ? "center" : "left")};
`;

export const Subtitle = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: ${({ $loud }) => ($loud ? 600 : 500)};
  font-size: ${({ $loud }) => ($loud ? "18px" : "13px")};
  color: ${({ $loud }) => ($loud ? "#1B2028" : "#5a6c87")};
  text-align: ${({ $loud }) => ($loud ? "center" : "left")};
  margin-bottom: ${({ $loud }) => ($loud ? "28px" : "24px")};
  line-height: ${({ $loud }) => ($loud ? "28px" : "22px")};
  max-width: ${({ $loud }) => ($loud ? "420px" : "none")};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: ${({ $loud }) => ($loud ? "center" : "flex-end")};
  align-items: center;
  width: 100%;
`;

export const StyledButton = styled.button`
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: ${({ $loud }) => ($loud ? "16px" : "14px")};
  border-radius: 6px;
  border: none;
  background-color: ${({ variant, $loud }) =>
    $loud
      ? "#16A34A"
      : variant === "warning"
        ? "#fdd835"
        : variant === "failure"
          ? "#B31514"
          : "#0c53bb"};
  color: ${({ variant }) => (variant === "warning" ? "#000" : "#fff")};
  padding: ${({ $loud }) => ($loud ? "14px 36px" : "10px 24px")};
  min-width: ${({ $loud }) => ($loud ? "180px" : "100px")};
  height: ${({ $loud }) => ($loud ? "52px" : "40px")};
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: ${({ variant, $loud }) =>
      $loud
        ? "#15803D"
        : variant === "warning"
          ? "#fdd835"
          : variant === "failure"
            ? "#a30e0d"
            : "#0c53bb"};
  }
`;
